// extracted by mini-css-extract-plugin
module.exports = {"btn":"remove-button__btn___3pZZt"};